import Axios from "@app/api/axios";

const updateGrade = (id, grades = null) => {
  const payload = { grades };
  return Axios.put(`reports/${id}`, payload).then((response) => response);
};
export default updateGrade;
